import styled, { css } from 'styled-components'

import IconInputError from '../assets/icons/icon-input-error.svg'
import IconInputSuccess from '../assets/icons/icon-input-success.svg'
import IconVisa from '../assets/img/pagamento/cartao-visa.svg'
import IconAmex from '../assets/img/pagamento/cartao-amex.svg'
import IconMaster from '../assets/img/pagamento/cartao-mastercard.svg'
import IconDiners from '../assets/img/pagamento/cartao-diners.svg'
import IconElo from '../assets/img/pagamento/cartao-elo.svg'
import IconCartao from '../assets/img/pagamento/cartao-default.svg'

export const Section = styled.section`
  background-color: rgb(251, 251, 251);
  padding: 32px 0;
`

export const div = styled.div``

export const PageContent = styled.div`
  margin: 32px 0;

  input {
    width: 200px !important;
  }
`
export const PerfilBox = styled.div`
  background: #fff;
  padding: 32px;
  border: 1px solid #e5e5e5;
  border-radius: 4px;
  -webkit-box-shadow: 0px 0px 4px rgb(0 0 0 / 10%);
  box-shadow: 0px 0px 4px rgb(0 0 0 / 10%);
  margin-bottom: 20px;

  @media (max-width: 1170px) {
    .perfil-box {
      padding: 30px 20px 10px 20px;
    }
  }
`

export const PerfilBoxP = styled.p`
  font-size: 15px;
  line-height: 22px;
`

export const TransacaoNegadaContent = styled.div`
  margin: 30px 0;

  .text-color-primary {
    margin-bottom: 20px;
    display: block;
  }

  .form-group {
    margin-bottom: 5px;
  }
`

export const TransacaoNegadaFooter = styled.div`
  display: inline-block;
`

export const TransacaoNegadaSubTitleBox = styled.div`
  position: relative;
  width: 100%;
  margin-bottom: 30px;
  &:before {
    content: '';
    display: block;
    width: 100%;
    height: 1px;
    background: #bbbbbb;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
  }
`

export const TransacaoNegadaSubTitleH5 = styled.h5`
  font-weight: normal;
  color: #707070;
  position: relative;
  background: #fff;
  display: inline-block;
  padding-right: 10px;
`

export const TransacaoNegadaNegadaColums = styled.div`
  display: flex;
  align-items: baseline;

  .selectValidade {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin-top: 4px;

    p {
      font-size: 12px;
    }
  }

  .selectValidade div {
    width: 100% !important;
    text-align: left !important;
  }

  @media (max-width: 1170px) {
    .selectValidade {
      display: flex;
      gap: 0;
      flex-direction: column;
      justify-content: space-between;
    }
    align-items: flex-start;
    flex-direction: column;
  }
`

export const TransacaoNegadaNegadaColum = styled.div`
  padding: 0 10px;
  margin-bottom: 10px;

  p {
    margin-top: 12px;
  }

  input {
    margin-bottom: -18px;
  }

  @media (max-width: 1170px) {
    padding: 0;
  }

  &:first-child {
    text-align: right;
    width: 30%;

    @media (max-width: 1170px) {
      text-align: left;
      width: 100%;
    }
  }

  .form-select {
    min-width: 180px;
    /* padding: 15px 35px 15px 15px; */

    @media (max-width: 1170px) {
      min-width: initial;
    }
  }

  &._validade {
    display: flex;

    .form-select {
      margin-right: 10px;

      &:last-child {
        margin-right: 0;
      }
    }
  }
`

export const PerfilTitleH2 = styled.h2`
  font-size: 22px;
  margin-bottom: 20px;
  color: #4a4a4a;
`
export const label = styled.label``

export const strong = styled.strong``

export const p = styled.p``

export const b = styled.b``

export const ButtonBack = styled.button`
  // Back.
  cursor: pointer;
  border-radius: 4px;
  border: 2px solid transparent;
  font-family: 'Montserrat', sans-serif;
  font-weight: 500;
  font-size: 14px;
  padding: 12px 16px;
  text-align: center;
  transition: all 400ms;

  background: #ffffff;
  border: 2px solid #d22630;
  color: #d22630;

  &:hover {
    border-color: #4a4a4a;
    color: #4a4a4a;
  }
`

export const Button = styled.button`
  cursor: pointer;
  border-radius: 4px;
  border: 2px solid transparent;
  font-family: 'Montserrat', sans-serif;
  font-weight: 500;
  font-size: 14px;
  padding: 12px 16px;
  text-align: center;
  transition: all 400ms;

  &.outline {
    cursor: default;
    background: transparent;
    color: #707070;
    border: 2px solid #707070;
  }

  & + .button {
    margin-left: 8px;

    /* @media (max-width: 1170px) {
      margin-left: 0;
    } */
  }

  background: #d22630;
  color: #fff;

  @media (max-width: 1170px) {
    font-size: 14px;
  }

  // Block.
  .button-block {
    display: block;
    width: 100%;
  }

  // Button Flex
  .button-elements {
    display: flex;
    width: 100%;
    align-items: center;
    justify-content: center;

    i {
      margin-right: 10px;
    }
  }
`

export const CardImage = styled.div`
  ${({ cartao }) => css`
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
    background-size: contain;
    display: flex;
    width: 81px;
    margin-left: 8px;
    margin-bottom: 0px !important;

    ${cartao === undefined || cartao === null
      ? css`
          background-image: url(${IconCartao});
        `
      : null}

    ${cartao === 'amex' &&
    css`
      background-image: url(${IconAmex});
    `}

    ${cartao === 'mastercard' &&
    css`
      background-image: url(${IconMaster});
    `}

    ${cartao === 'visa' &&
    css`
      background-image: url(${IconVisa});
    `}

    ${cartao === 'elo' &&
    css`
      background-image: url(${IconElo});
    `}

    ${cartao === 'diners' &&
    css`
      background-image: url(${IconDiners});
    `}
  `}
`

export const Wrapper = styled.div`
  max-width: 1360px;
  margin: 0 auto;
  position: relative;
  width: 100%;

  @media (max-width: 1390px) {
    max-width: 95%;
  }
`
export const ColGroup = styled.div`
  max-width: 1360px;
  display: flex;
  justify-content: center;
  align-items: flex-start;

  @media (max-width: 1170px) {
    .col-3 {
      display: none;
    }

    .col-9 {
      width: 100%;
    }
  }
`
export const ProfileContent = styled.div``

export const Fichas = styled.div`
  display: flex;
  flex-wrap: wrap;
  /* justify-content: space-between; */
  gap: 16px;
`

export const ProfileMenu = styled.nav`
  margin-right: 15%;
`

export const ProfileBox = styled.div`
  background: #ffffff;
  padding: 30px 30px 30px 30px;
  border: 1px solid #e5e5e5;
  border-radius: 4px;
  -webkit-box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.1);
  box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.1);
  margin-bottom: 20px;
`

export const ProfileBoxFooter = styled.div`
  margin: 10px 0 20px 0;
`

export const ButtonAddNewAddress = styled.button`
  ${({ theme }) => css`
    border-radius: 5px;
    border: 2px solid transparent;
    font-family: 'Montserrat', sans-serif;
    font-weight: 500;
    font-size: 14px;
    padding: 12px 16px;
    text-align: center;
    transition: ${theme.transition.default};
    cursor: pointer;
    background: ${theme.colors.primary};
    color: ${theme.colors.white};

    &:hover {
      background: #a71e26;
    }

    & + .button {
      margin-left: 15px;
    }

    @media (max-width: ${theme.media.ipad}) {
      font-size: 14px;
    }
  `}
`
